module.exports = __webpack_public_path__ + "img/38.2c2aa4a6.jpg";